/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import { Filter } from "@/components/Svg";
import SingleJobsDetail from "@/components/web/main/single job/SingleJobsDetail";
import { PER_PAGE } from "@/configs/constants";
import { Button, Container, Indicator } from "@mantine/core";
import { useEffect, useState } from "react";
import {
  useParams,
  usePathname,
  useRouter,
  useSearchParams,
} from "next/navigation";
import CPaginationWithLinks from "@/components/main/CPaginationWithLinks";
import JobsAdvancedSearchModal from "@/components/web/main/jobs/JobsAdvancedSearchModal";

const JobsPage = ({ dictionary, jobsData }) => {
  const [count, setCount] = useState(0);
  const searchParams = useSearchParams();
  const params = useParams();

  const pathName = usePathname();
  const router = useRouter();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [showAdvancedSeach, setShowAdvancedSearch] = useState(false);
  const [searchItems, setSearchItems] = useState({});
  const [searchItemsLoaded, setSearchItemsLoaded] = useState(false);
  const [seachText, setSearchText] = useState("");

  useEffect(() => {
    let temp = {};
    setPage(params?.page ? parseInt(params?.page) : 1);

    for (let [key, value] of searchParams.entries()) {
      if (key == "sectors") {
        value = searchParams.getAll("sectors");
      }
      if (key == "organizations") {
        value = searchParams.getAll("organizations");
      }
      if (key == "postDate") {
        value = new Date(searchParams.get("postDate"));
      }
      if (key == "minExperience") {
        value = new Number(searchParams.get("minExperience"));
      }
      temp[key] = value;
    }
    setSearchItems(temp);
    setSearchItemsLoaded(true);
  }, [searchParams]);

  const onFilterApply = (values) => {
    router.push(
      `${pathName.split("/page")[0]}?${Object.entries(values)
        .filter((item) => item[1])
        .map((item) => {
          return Array.isArray(item[1])
            ? item[1]
              .map((item2) => `${item[0]}=${encodeURIComponent(item2)}&`)
              .join("")
            : `${item[0]}=${encodeURIComponent(item[1])}&`;
        })
        .join("")}`,
      { scroll: false }
    );
  };

  return (
    <>
      <JobsAdvancedSearchModal
        show={showAdvancedSeach}
        setShow={setShowAdvancedSearch}
        dictionary={dictionary}
        onApply={onFilterApply}
        values={searchItems}
      />
      <Container>
        <div className="flex justify-between items-center mt-[35px] mb-[26px]">
          <p className="text-textGrey text-lg leading-5">
            <span className="font-bold">
              {Intl.NumberFormat("en", {
                notation: "compact",
              }).format(count)}
            </span>{" "}
            {dictionary.availableJobs}
          </p>
          <Indicator
            disabled={
              Object.keys(searchItems).filter(
                (item) => item != "page" && item != "search"
              ).length == 0
            }
            label={
              Object.keys(searchItems).filter(
                (item) => item != "page" && item != "search"
              ).length
            }
            size={20}
            color="blue.8"
          >
            <Button
              variant="outline"
              style={{ borderWidth: "2px", height: "44px" }}
              leftIcon={<Filter className="hover:fill-white" />}
              onClick={() => {
                setShowAdvancedSearch(true);
              }}
            >
              {dictionary.advancedSearch}
            </Button>
          </Indicator>
        </div>
        <SingleJobsDetail
          dictionary={dictionary}
          count={count}
          setCount={setCount}
          page={page}
          perPage={PER_PAGE}
          loadingOutside={loading}
          setLoadingOutside={setLoading}
          searchItems={searchItems}
          seachText={seachText}
          searchItemsLoaded={searchItemsLoaded}
          jobsData={jobsData}
        />
        <CPaginationWithLinks
          value={page}
          totalPages={Math.ceil(count / PER_PAGE)}
          dictionary={dictionary}
          searchItems={searchItems}
        />
      </Container>
    </>
  );
};

export default JobsPage;
